import { Layout } from 'antd';
import React from 'react';
import { Route, RouteComponentProps, RouteProps, Switch } from 'react-router-dom';

import Content from '@/Layout/components/Content';
import TopSider from '@/Layout/components/TopSider';

type Props = RouteComponentProps & {
  routes: RouteProps[];
};

const TopRouter: React.FC<Props> = (props) => (
  <Layout>
    <TopSider />
    <Content>
      <Switch>
        {props.routes.map((route, i) => (
          // eslint-disable-next-line react/no-array-index-key, react/jsx-props-no-spreading
          <Route key={i} {...route} />
        ))}
      </Switch>
    </Content>
  </Layout>
);

export default TopRouter;
